import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    chip: {
      display: 'inline-flex',
      alignItems: 'center',
      padding: '5px 12px',
      borderRadius: 999,
      fontSize: '12.5px',
      fontWeight: 600,
      lineHeight: 1.2,
      whiteSpace: 'nowrap',
    },
    sectionLabel: {
      fontSize: '12px',
      fontWeight: 600,
      textTransform: 'uppercase',
      letterSpacing: '0.6px',
      color: theme.palette.text.secondary,
    },
    hint: {
      fontSize: '12px',
      color: theme.palette.text.secondary,
      lineHeight: 1.45,
    },
    optionsRow: {
      display: 'flex',
      gap: 8,
      marginTop: theme.spacing(1),
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    optionCard: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'flex-start',
      gap: 12,
      flex: '1 1 0',
      minWidth: 0,
      width: '100%',
      textAlign: 'left',
      textTransform: 'none',
      padding: '12px 14px',
      borderRadius: 12,
      border: `1.5px solid ${theme.palette.divider}`,
      background: theme.palette.background.paper,
      cursor: 'pointer',
    },
    optionCardActive: {
      borderColor: theme.palette.primary.main,
    },
    optionCardEligible: {
      borderColor: theme.palette.success.main,
    },
    appliesBanner: {
      display: 'flex',
      alignItems: 'flex-start',
      gap: 12,
      padding: 14,
      borderRadius: 14,
      border: `1px solid ${theme.palette.success.main}`,
    },
    blockersList: {
      margin: 0,
      paddingLeft: 18,
    },
    monospace: {
      fontFamily: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    },
  })
);
